<template>
  <div>
    <v-data-table
      show-select
      v-model="selected"
      :headers="headers"
      :items="data"
      :loading="loading"
      hide-default-footer
      :items-per-page="24"
      class="elevation-1 text-overflow my-10"
      @item-selected="handleSelectedRow"
      item-key="uuid"
      @toggle-select-all="handleSelectedRow"
      @click:row="previewItem"
    >
      <!-- style="cursor:pointer" -->
      <template v-slot:top>
        <v-row class="mx-4">
          <v-toolbar flat height="70">
            <!-- <v-row class="mt-4"> -->
            <v-col cols="5" sm="3" md="3" lg="3" xl="2" class="pl-0">
              <v-row justify="start" class="ml-1">
                <v-toolbar-title class="headline" :data-cy="title">
                  <span>
                    {{ title }}
                  </span>
                  <v-btn
                    v-if="canUseKnowledgeBaseBtn"
                    @click="handleHelp"
                    icon
                    color="primary"
                  >
                    <v-icon>mdi-help-circle</v-icon>
                  </v-btn>
                </v-toolbar-title>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="7" lg="6" xl="4" class="mt-7">
              <v-row justify="center">
                <v-col cols="8">
                  <maintenance-boat-selector
                    :initial-boat-uuid="query.crm_boat_uuid"
                    :show-selected-boat="false"
                    :maintenance-content="true"
                    :select-first="true"
                    :clearable="true"
                    @loaded="handleMount('boatSelector')"
                    @change="handleBoatSelection"
                  ></maintenance-boat-selector>
                </v-col>
                <v-col cols="3" md="4" sm="4">
                  <v-select
                    v-model="query.service_status"
                    :items="statusFilterOptions"
                    item-text="name"
                    item-value="value"
                    color="primary"
                    @change="handleStatusFilter"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2"> </v-col>
          </v-toolbar>
        </v-row>
        <v-row class="mx-6">
          <v-col cols="12">
            <slot name="alert"></slot>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.overdueMileage="{ item }">
        <span>
          <span
            v-if="
              getEngineHours(item.engine_seconds) -
                getEngineHours(item.should_be_engine_seconds_before) >
              0
            "
          >
            {{
              $t("components.lists.servicesList.hoursAgo", {
                hours:
                  getEngineHours(item.engine_seconds) -
                  getEngineHours(item.should_be_engine_seconds_before),
              })
            }}
          </span>
          <span v-else>
            {{
              $t("components.lists.servicesList.hoursLeft", {
                hours: Math.abs(
                  getEngineHours(item.engine_seconds) -
                    getEngineHours(item.should_be_engine_seconds_before)
                ),
              })
            }}
          </span>
        </span>
      </template>
      <template v-slot:item.overdueTime="{ item }">
        <span v-if="getDaysLeftDate(item.should_be_done_before) !== null">
          <span v-if="getDaysLeftDate(item.should_be_done_before) > 0">
            {{
              $t("components.lists.servicesList.daysLeft", {
                days: getDaysLeftDate(item.should_be_done_before),
              })
            }}</span
          ><span v-if="getDaysLeftDate(item.should_be_done_before) <= 0">
            {{
              $t("components.lists.servicesList.daysAgo", {
                days: Math.abs(getDaysLeftDate(item.should_be_done_before)),
              })
            }}</span
          ></span
        >
      </template>
      <template v-slot:item.doneMileage="{ item }">
        <span v-if="item.engine_seconds_completed !== null">
          <span>{{ getEngineHours(item.engine_seconds_completed) }}</span>
        </span>
      </template>
      <template v-slot:item.doneTime="{ item }">
        <span v-if="item.completed !== null">
          <span>{{ $moment(item.completed).format("YYYY-MM-DD") }}</span>
        </span>
      </template>
      <template v-slot:item.action="{ item }">
        <div
          style="height: 40px; width: 120px"
          class="pt-2 float-right"
          onclick="event.stopPropagation()"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="item.crm_internal_task === null"
                class="mx-2 edit--hover"
                @click="createTask(item)"
              >
                {{ item.icon }}
              </v-icon>
              <v-icon
                v-on="on"
                v-else
                class="mx-2 edit--hover"
                @click="openTask(item.crm_internal_task.uuid)"
              >
                mdi-link
              </v-icon>
            </template>
            <span v-if="item.crm_internal_task === null">Create a task</span>
            <span v-else>Open a task</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mx-2 edit--hover"
                @click="openEdit(item)"
              >
                {{
                  item.serviceIcon ? item.serviceIcon : "mdi-wrench-cog-outline"
                }}
              </v-icon>
            </template>
            <span>New entry for boat service history</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.is_critical="{ item }">
        <v-chip
          v-if="item.service_status === 'complete'"
          class="ma-2"
          dark
          color="green"
        >
          {{ $t("components.lists.servicesList.done") }}
        </v-chip>
        <v-chip
          v-if="item.service_status === 'overdue'"
          class="ma-2"
          dark
          color="red"
        >
          {{ $t("components.lists.servicesList.overdue") }}
        </v-chip>
        <v-chip
          v-if="
            item.requires_attention &&
            ['upcoming', 'overdue', 'complete'].indexOf(item.service_status) ===
              -1
          "
          class="ma-2"
          dark
          color="red"
        >
          {{ $t("components.lists.servicesList.dueSoon") }}
        </v-chip>
        <v-chip
          v-if="!item.requires_attention && item.service_status === 'upcoming'"
          class="ma-2"
          dark
          color="orange"
        >
          {{ $t("components.lists.servicesList.upcoming") }}
        </v-chip>
      </template>
      <template v-slot:item.crm_internal_task="{ item }">
        <v-chip
          class="ma-2"
          dark
          color="green"
          v-if="item.crm_internal_task !== null"
        >
          <span v-if="item.crm_internal_task.assignee_status === 'PENDING'">{{
            $t("components.lists.servicesList.created")
          }}</span>
          <span v-else>{{ $t("components.lists.servicesList.assigned") }}</span>
        </v-chip>
        <!-- <v-chip v-else class="ma-2" dark color="orange">
          Pending
        </v-chip> -->
      </template>
      <template v-slot:item.crm_service="{ item }">
        <span v-if="item.crm_service !== null">{{
          item.crm_service.short_task
        }}</span>
      </template>
      <template v-slot:item.should_be_done_before="{ item }">
        <span v-if="item.completed !== null">
          <span>{{ $moment(item.completed).format("YYYY-MM-DD") }}</span>
        </span>
        <span
          v-if="
            getDaysLeftDate(item.should_be_done_before) !== null &&
            item.completed === null
            "
        >
          <span v-if="getDaysLeftDate(item.should_be_done_before) > 0">
            {{
              $t("components.lists.servicesList.daysLeft", {
                days: getDaysLeftDate(item.should_be_done_before),
              })
            }}</span
          ><span v-if="getDaysLeftDate(item.should_be_done_before) <= 0">
            {{
              $t("components.lists.servicesList.daysAgo", {
                days: Math.abs(getDaysLeftDate(item.should_be_done_before)),
              })
            }}</span
          ></span
        >
      </template>
      <template v-slot:item.should_be_engine_seconds_before="{ item }">
        <span
          v-if="
            getEngineHours(item.engine_seconds) !== 0 &&
            getEngineHours(item.should_be_engine_seconds_before) !== 0
          "
          >{{ getEngineHours(item.engine_seconds) }}/{{
            getEngineHours(item.should_be_engine_seconds_before)
          }}
        </span>
      </template>

      <template v-slot:item.crm_boat="{ item }">
        <div v-if="item.crm_boat">
          <span v-if="item.crm_boat"
            >{{ item.crm_boat.model.brand_name }}
            {{ item.crm_boat.model.model }} #{{ item.crm_boat.slot_number }}
          </span>
          <!-- <v-btn icon @click="openBoat(item.crm_boat.uuid)">
            <v-icon color="primary">mdi-link</v-icon>
          </v-btn> -->
        </div>
      </template>
      <template v-slot:item.crm_boat_item="{ item }">
        <div v-if="item.crm_boat_item">
          <span>{{ item.crm_boat_item.crm_item.formatted_name }} </span>
          <!-- <v-btn icon @click="openItem(item.crm_boat_item.uuid)">
            <v-icon color="primary">mdi-link</v-icon>
          </v-btn> -->
        </div>
      </template>
    </v-data-table>
    <v-pagination
      v-model="currentPage"
      :length="numberOfPages"
      :total-visible="7"
      color="primary"
    />
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </div>
</template>

<script>
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";
import MaintenanceBoatSelector from "@/components/selectors/MaintenanceBoatSelector.vue";

export default {
  props: {
    title: String,
    headers: Array,
    data: Array,
    sort: String,
    loading: Boolean,
    response: Object,
  },

  components: {
    HelpDialog,
    MaintenanceBoatSelector,
  },

  data: () => ({
    mounted: {
      boatSelector: { mounted: false, refs: "boatSelector" },
      root: { mounted: false, refs: null },
    },
    query: {
      page: 1,
      crm_boat_uuid: "",
      service_status: "",
    },
    selected: [],
    statusFilterOptions: [],
    canUseKnowledgeBaseBtn: false,
    helpDialog: { location: null, active: false },
  }),
  created() {
    this.setInitalData();

    this.canUseKnowledgeBaseBtn =
      constraints.canUseKnowledgeBaseBtn("services");

    this.query.crm_boat_uuid = this.$route.query.crm_boat_uuid || "";
    this.query.page = Number(this.$route.query.page) || 1;
    this.query.service_status = this.$route.query.service_status || "upcoming";
  },

  computed: {
    formTitle() {
      return this.title.substring(0, this.title.length - 1);
    },
    numberOfPages() {
      if (!this.response) {
        return 0;
      }
      return parseInt(Math.ceil(this.response.count / 24));
    },
    currentPage: {
      get: function () {
        return this.query.page;
      },
      set: function (value) {
        this.query = {
          ...this.query,
          page: value,
        };
        this.$emit("reload");
      },
    },
  },
  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.    this.mounted = true;
    this.handleMount("root");
  },

  methods: {
    setInitalData() {
      this.statusFilterSelected = "upcoming";
      this.statusFilterOptions = [
        {
          name: this.$t("components.lists.servicesList.all"),
          value: "",
        },
        {
          name: this.$t("components.lists.servicesList.done"),
          value: "complete",
        },
        {
          name: this.$t("components.lists.servicesList.overdue"),
          value: "overdue",
        },
        {
          name: this.$t("components.lists.servicesList.upcoming"),
          value: "upcoming",
        },
      ];
    },

    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error(
          "SERVICES_UPCOMING_LIST:component name does not exists",
          componentName
        );
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.$emit("mounted", true);
      }
    },

    handleSelectedRow(item) {
      if (typeof item.item === "undefined") {
        this.data.forEach((element) => {
          element.icon = item.value
            ? "mdi-checkbox-multiple-marked-circle-outline"
            : "mdi-calendar-plus";
          element.serviceIcon = item.value
            ? "mdi-wrench-check-outline"
            : "mdi-wrench-cog-outline";
        });
        return;
      }

      let index = this.data.findIndex(
        (element) => element.uuid === item.item.uuid
      );
      this.data[index].icon = item.value
        ? "mdi-checkbox-multiple-marked-circle-outline"
        : "mdi-calendar-plus";

      this.data[index].serviceIcon = item.value
        ? "mdi-wrench-check-outline"
        : "mdi-wrench-cog-outline";
    },
    handleBoatSelection(event) {
      this.selected = [];
      this.query.page = 1;
      this.query.crm_boat_uuid = event.uuid;
      this.$emit("boat", event);
      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.$emit("reload");
        //this.$emit("mounted", true);
      }
    },
    createTask(service) {
      if (this.selected.length >= 2) {
        this.$router.pushAsync({ name: "tasksNew" }).then(() => {
          this.$store.commit("SET_SERVICES", {
            from: "services",
            services: this.selected,
          });
        });
      } else {
        this.$router.pushAsync({ name: "tasksNew" }).then(() => {
          this.$store.commit("SET_SERVICES", {
            from: "services",
            services: [service],
          });
        });
      }
    },
    openTask(uuid) {
      this.$emit("task", uuid);
    },
    openItem(uuid) {
      this.$emit("item", uuid);
    },
    getDaysLeftDate(item) {
      return item !== null
        ? this.$moment(item).diff(this.$moment(), "days")
        : null;
    },
    getEngineHours(item) {
      return Math.round(item / 3600);
    },
    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "services";
    },
    previewItem(event) {
      this.$emit("preview", event);
    },
    handleStatusFilter() {
      this.query.page = 1;
      this.$emit("reload");
    },

    openEdit(service) {
      if (this.selected.length === 0) {
        this.$emit("edit", [service]);
        return;
      }

      this.$emit("edit", this.selected);
    },
  },
};
</script>

<style lang="scss">
.text--capitalize {
  text-transform: capitalize;
}

.delete--hover {
  &:hover {
    color: red;
  }
}

.preview--hover {
  &:hover {
    color: --secondary;
  }
}

.edit--hover {
  &:hover {
    color: --primary;
  }
}
.copy--hover {
  &:hover {
    color: --primary;
  }
}
</style>
